<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @add="ChoosePurchaseVisible = true"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <ChoosePurchaseDialog
      :visible.sync="ChoosePurchaseVisible"
      :title="'选择TC面料采购单'"
      @confirm="onChoosePurchaseConfirm"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import ChoosePurchaseDialog from '../choose-purchase'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, ChoosePurchaseDialog },
  data() {
    return {
      usePage: true,
      ChoosePurchaseVisible: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .tcFabricSalesListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChoosePurchaseConfirm({ tcFabricPurchaseCode }) {
      if (!tcFabricPurchaseCode) return
      this.openEditPage({ pageType: 'add', query: { tcFabricPurchaseCode } })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'tc-fabricSell-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
